// import { createMuiTheme } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import { zhCN } from '@material-ui/core/locale';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';
import { softShadows } from './shadows';
// import themes from './themes/index';

import { merge } from 'lodash-es';

const baseTheme = {
  palette,
  typography,
  shadows: softShadows,
  components: overrides,
};

const buildTheme = () => {
  let theme;
  theme = createTheme(
    merge(
      { ...baseTheme },
      {
        components: {
          ...baseTheme.components,
          MuiCssBaseline: {
            styleOverrides: {
              html: {
                WebkitFontSmoothing: 'auto',
                fontSize: 14,
                fontFamily: 'Source Han Sans CN, Arial, sans-serif',
              },
            },
          },
          MuiInputLabel: {
            styleOverrides: {
              root: {
                // top: '-5px',
              },
            },
          },
          MuiInputBase: {
            styleOverrides: {
              root: {
                // marginTop: 'auto !important',
                // '&.Mui-error': {
                //   marginTop: '16px !important',
                // },
              },
              input: {
                // height: '100%',
              },
              multiline: {
                height: 'auto',
              },
            },
          },
          MuiCard: {
            styleOverrides: {
              root: {
                borderRadius: '4px',
                boxShadow: '0px 0px 5px 0px rgba(181, 181, 181, 0.26)',
                overflow: 'visible !important',
              },
            },
          },
          MuiSvgIcon: {
            styleOverrides: {
              root: {
                top: 'auto !important',
                width: 24,
                height: 24,
              },
            },
          },
          MuiFormControl: {
            styleOverrides: {
              root: {
                height: 40,
                fontSize: 14,
                fontFamily: 'Source Han Sans CN, Arial, sans-serif',
                color: '#000',
              },
            },
          },
          // MuiFormLabel: {
          //   styleOverrides: {
          //     root: {},
          //   },
          // },
          // MuiFormHelperText: {
          //   styleOverrides: {
          //     root: {
          //       marginLeft: 14,
          //     },
          //   },
          // },
          MuiFab: {
            styleOverrides: {
              root: {
                fontSize: 14,
                lineHeight: 'inherit',
              },
            },
          },
          MuiFormHelperText: {
            styleOverrides: {
              root: {
                fontSize: 12,
              },
            },
          },
        },
      },
    ),
    zhCN,
  );
  // theme = createTheme(baseTheme, zhCN);
  // console.log('💢felix => buildTheme => theme', theme.typography);
  return theme;
};

export default buildTheme;
